import React, { Component } from "react";
import { observer } from "mobx-react";
import { fn_setIncompleteFlag, fn_change_view_order, fn_change_view_type } from "function/FnBodySetting";
import { kdsSetYn } from "utils/Utils";
import settingImg1 from "static-file/images/img_use_setting1.png";
import settingImg2 from "static-file/images/img_use_setting2.png";
import settingImg3 from "static-file/images/img_use_setting3.png";
import settingImg4 from "static-file/images/img_use_setting4.png";

@observer
class SettingDefaultUseOrderView extends Component {
  componentDidMount() {
    const { rootStore } = this.props;
    const settingStore = rootStore.settingStore;
    settingStore.setSettingUseMenu("use");
    settingStore.setSettingView(false);
  }

  render() {
    const { rootStore } = this.props;
    const settingStore = rootStore.settingStore;

    return (
      <div className="scroll tab">
        <div className="inner">
          <div className="wrap">
            <div className="box_tit">
              <h4>주문현황 화면</h4>
            </div>
            <div className="box">
              <div className="item">
                <label>
                  <input
                    type="radio"
                    name="item1"
                    checked={settingStore.getOrderViewType === "list" ? true : ""}
                    onChange={event => {
                      fn_change_view_type(rootStore, "list");
                    }}
                  />
                  <span className="ico"></span>
                  <span className="cont">
                    <span className="thumb">
                      <img src={settingImg1} />
                    </span>
                    <strong className="tit">리스트 화면</strong>
                    <span className="txt">(페이지당 주문 10개)</span>
                  </span>
                </label>
              </div>
              <div className="item">
                <label>
                  <input
                    type="radio"
                    name="item1"
                    checked={settingStore.getOrderViewType === "card" ? true : ""}
                    onChange={event => {
                      fn_change_view_type(rootStore, "card");
                    }}
                  />
                  <span className="ico"></span>
                  <span className="cont">
                    <span className="thumb">
                      <img src={settingImg2} />
                    </span>
                    <strong className="tit">카드 화면</strong>
                    <span className="txt">(페이지당 주문 8개)</span>
                  </span>
                </label>
              </div>
            </div>
            <div className="box_tit">
              <h4>
                주문 정렬<span>주문현황 화면에서 주문 정렬 기준 선택</span>
              </h4>
            </div>
            <div className="box last">
              <div className="item">
                <label>
                  <input
                    type="radio"
                    name="item2"
                    checked={settingStore.getOrderViewOrder === "asc" ? true : ""}
                    onChange={event => {
                      fn_change_view_order(rootStore, "asc");
                    }}
                  />
                  <span className="ico"></span>
                  <span className="cont">
                    <span className="thumb">
                      <img src={settingImg3} />
                    </span>
                    <strong className="tit">기본 순서</strong>
                    <span className="txt">(신규 주문이 최하단/맨 뒤에 위치)</span>
                  </span>
                </label>
              </div>
              <div className="item">
                <label>
                  <input
                    type="radio"
                    name="item2"
                    checked={settingStore.getOrderViewOrder === "desc" ? true : ""}
                    onChange={event => {
                      fn_change_view_order(rootStore, "desc");
                    }}
                  />
                  <span className="ico"></span>
                  <span className="cont">
                    <span className="thumb">
                      <img src={settingImg4} />
                    </span>
                    <strong className="tit">최신순 정렬</strong>
                    <span className="txt">(신규 주문이 최상단/맨 앞에 위치)</span>
                  </span>
                </label>
              </div>
            </div>
            {rootStore.settingStore.getMainPosType == "Y" && kdsSetYn(rootStore) ? (
              <div className="box_tit incomplete">
                <h4 className="incomplete">미완료 메뉴보기 사용 설정</h4>
                <h5 className="incomplete">사이드바에 미완료메뉴 버튼을 표시합니다.</h5>
                <div className="lab_check">
                  <input
                    type="checkbox"
                    name="aaa"
                    id="checkbox1"
                    className="inp"
                    checked={settingStore.getProgressingExposeFlag === "Y" ? true : false}
                    onChange={event => {
                      fn_setIncompleteFlag(rootStore);
                    }}
                  />
                  <label className="lab_toggle" htmlFor="checkbox1"></label>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

export default SettingDefaultUseOrderView;
